import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Airplane({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M3 12L2 8H3.8C3.9 8 4.1 8.1 4.2 8.2L5.8 10L10.6 10L7.4 2.7C7.2 2.4 7.4 2 7.8 2H9.5C9.8 2 10.1 2.2 10.3 2.4L15.3 10H20C21.1 10 22 10.9 22 12C22 13.1 21.1 14 20 14H15.3L10.3 21.6C10.1 21.9 9.8 22 9.5 22H7.8C7.4 22 7.2 21.6 7.3 21.3L10.5 14L5.7 14L4.1 15.8C4 15.9 3.9 16 3.7 16H2L3 12Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Airplane;